import { useQuery } from '@tanstack/react-query'
import { z } from 'zod'
import { httpClient } from '@/shared/lib/httpClient'
import { apiV1 } from '@/shared/api/apiPrefix'

const quotaResultSchema = z.object({
  data: z.object({
    allowed: z.boolean(),
    remaining: z.number(),
    max_count: z.number(),
    resets_at: z.string().nullable().optional(),
  }),
})

export type QuotaResult = {
  allowed: boolean
  remaining: number
  maxCount: number
  resetsAt: Date | null
}

export function useQuota(resourceType: string, resourceId?: string) {
  return useQuery({
    queryKey: ['quota', resourceType, resourceId ?? null],
    enabled: resourceType.length > 0,
    staleTime: 30_000,
    queryFn: async (): Promise<QuotaResult> => {
      const params = new URLSearchParams({ resource_type: resourceType })
      if (resourceId) params.set('resource_id', resourceId)
      const res = await httpClient.get<unknown>(apiV1(`/me/quota?${params.toString()}`))
      const parsed = quotaResultSchema.parse(res.data).data

      return {
        allowed: parsed.allowed,
        remaining: parsed.remaining,
        maxCount: parsed.max_count,
        resetsAt: parsed.resets_at ? new Date(parsed.resets_at) : null,
      }
    },
  })
}
